import { Link } from "react-router-dom";
import styles from "../styles/pages.module.css";

export default function MudanzasFuenlabrada() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Mudanzas en Fuenlabrada, Madrid</h1>
        <span className={styles.lastUpdated}>Mudanzas rápidas y seguras en Fuenlabrada y zona sur de Madrid</span>

        <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
          <img
            src="/assets/images/carousel-4.webp"
            alt="Mudanzas en Fuenlabrada"
            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
          />
        </div>

        <p>
          Britosa Mudanzas lleva más de 25 años realizando <strong>mudanzas en Fuenlabrada</strong> y en toda el área metropolitana sur de Madrid. Desde nuestro centro de operaciones en Móstoles, llegamos a cualquier punto de Fuenlabrada en menos de 20 minutos, lo que nos permite ofrecer tiempos de respuesta ágiles y precios muy competitivos.
        </p>

        <h2>Mudanzas adaptadas a Fuenlabrada</h2>
        <p>
          Fuenlabrada es una ciudad joven, dinámica y con una gran diversidad de tipos de vivienda: desde pisos en el centro hasta chalets en zonas residenciales como Loranca o el Molino de la Hoz. Sea cual sea tu caso, en Britosa tenemos la solución a medida.
        </p>

        <h2>Nuestros servicios en Fuenlabrada</h2>
        <ul>
          <li><strong>Mudanzas locales:</strong> Dentro de Fuenlabrada o hacia Móstoles, Alcorcón, Leganés, Getafe y Madrid.</li>
          <li><strong>Mudanzas de pisos:</strong> Desde estudios hasta áticos dúplex con terraza.</li>
          <li><strong>Mudanzas de chalets:</strong> Voluminosos jardines, garajes, trasteros y mobiliario exterior.</li>
          <li><strong>Mudanzas de comercios:</strong> Tiendas, locales de hostelería y pequeñas industrias.</li>
          <li><strong>Transporte de pianos y objetos frágiles:</strong> Técnicos especializados y seguro ampliado.</li>
        </ul>

        <h2>Barrios y zonas de Fuenlabrada</h2>
        <p>
          Loranca, La Paz, El Molino, Arroyo Culebro, Parque de los Estados, El Naranjo, El Arroyo, Cuzco, Fuenlabrada Centro, San Mateo y todas las urbanizaciones del entorno. Conocemos las mejores rutas y los horarios de mayor fluidez.
        </p>

        <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "1.25rem", margin: "1.5rem 0", border: "1px solid #bae6fd" }}>
          <h3 style={{ marginTop: 0, color: "#0F4C75" }}>Tu mudanza en Fuenlabrada empieza aquí</h3>
          <p style={{ marginBottom: "1rem" }}>
            Cuéntanos el origen y destino de tu mudanza en Fuenlabrada y te damos un presupuesto cerrado sin sorpresas.
          </p>
          <Link to="/presupuesto" style={{ display: "inline-block", padding: "0.6rem 1.4rem", background: "#F97316", color: "#fff", borderRadius: "6px", textDecoration: "none", fontWeight: 600 }}>
            Pedir presupuesto →
          </Link>
        </div>

        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "2rem" }}>
          <a href="tel:+34691604880">691 60 48 80</a> · <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a>
        </p>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Britosa Mudanzas - Fuenlabrada",
          "description": "Mudanzas rápidas y seguras en Fuenlabrada, Madrid. Precios competitivos desde Móstoles.",
          "url": "https://mudanzasbritosa.com/mudanzas-fuenlabrada",
          "telephone": "+34691604880",
          "email": "info@mudanzasbritosa.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "C. Río Duero, 28934 Móstoles",
            "addressLocality": "Fuenlabrada, Madrid",
            "addressRegion": "Madrid",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.2842,
            "longitude": -3.7942
          },
          "areaServed": {
            "@type": "City",
            "name": "Fuenlabrada"
          },
          "priceRange": "€€",
          "openingHours": "Mo-Su 08:00-22:00"
        })
      }} />
    </div>
  );
}
